var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynIconTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.39762C3.8731 3.91483 10.2418 3.89552 13 3.91483M12.0136 6.08741C12.0136 9.32214 11.2187 13.0493 10.3472 14.5943C9.65762 15.8206 4.0838 15.8206 3.51876 14.4784C2.73344 12.6245 1.9577 8.47242 1.9577 6.32881M5.19473 1.9933C5.30966 1.52016 5.35754 1.47188 7.14844 1.51051C8.68077 1.54913 8.90104 1.51051 9.10216 1.9933M9.14046 8.25999C9.00639 10.0753 8.42219 12.8465 8.42219 12.8465M4.83081 8.25999C5.07023 9.94977 5.30966 11.3982 5.78851 12.8465",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynIconTrashCan);
export default __webpack_public_path__ + "static/media/dyn-icon-trash-can.243ce24272e484cfe5ae134587f8a46d.svg";
export { ForwardRef as ReactComponent };